module.exports = __webpack_public_path__ + "img/guide5.e4bf98ed.jpg";